import { Injectable } from '@angular/core';
import { QuizMessage } from '../../../../bayadic-shared-models/classes/quiz/quiz-message';
import { Chat } from '../../../../bayadic-shared-models/chat/Chat';

@Injectable({
  providedIn: 'root'
})
export class QuizDataService {
  private quizData: {
    chat: Chat;
    quizMessages: QuizMessage[];
  } | null = null;

  setQuizData(chat: Chat, quizMessages: QuizMessage[]) {
    this.quizData = { chat, quizMessages };
  }

  getQuizData() {
    return this.quizData;
  }

  clearQuizData() {
    this.quizData = null;
  }
} 